module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAAWUlEQVQ4y2P8//8/AyWAiYFCwIJLgrGTAcNp/8sZGIk2AF0DNgMZGBgYGGFhgEsBQQv+//+Pghk6/v9HF8Mnz0QoDNBpqsfCqAEMDBRHIwuxyRhndA94bgQAXIl1/3bJGv0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/form/icon_delete_1.png
// module id = 2047
// module chunks = 50